import { z } from "zod";
export const UserIdentity = z.object({
    id: z.string(),
    userId: z.string(),
});
